import { Toaster as Sonner, type ToasterProps } from 'sonner';
import { useIsMobile } from '../../hooks/use-is-mobile';

const Toaster = ({ ...props }: ToasterProps) => {
  const isMobile = useIsMobile();

  return (
    <Sonner
      position={isMobile ? 'top-center' : 'bottom-right'}
      className="toaster group"
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
